exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".natp-teaser-container{padding:0 8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/scripts/components/teaserContent/teaserContent.css
// module id = 43
// module chunks = 0